import { render, staticRenderFns } from "./CampaignUserDraft.vue?vue&type=template&id=f4cb5744&scoped=true"
import script from "./CampaignUserDraft.vue?vue&type=script&lang=js"
export * from "./CampaignUserDraft.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserDraft.vue?vue&type=style&index=0&id=f4cb5744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb5744",
  null
  
)

export default component.exports